export default (function (_ref) {
  var request = _ref.request;
  return {
    breedModeAdd: function breedModeAdd(data) {
      return request({
        url: '/cms/breedMode/add',
        method: 'post',
        data: data
      });
    },
    breedModeModify: function breedModeModify(data) {
      return request({
        url: "/cms/breedMode/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    breedModeDel: function breedModeDel(id) {
      return request({
        url: "/cms/breedMode/".concat(id, "/del"),
        method: 'delete'
      });
    },
    breedModeQuery: function breedModeQuery(data) {
      return request({
        url: '/cms/breedMode',
        method: 'get',
        params: data
      });
    },
    breedModeDetail: function breedModeDetail(id) {
      return request({
        url: "/cms/breedMode/".concat(id),
        method: 'get'
      });
    }
  };
});